import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

function epoch_min2date(epoch_min) {
    const date = new Date(epoch_min * 60 * 1000);
    return date.toLocaleString();
}

function CallFallsBlock(block, epoch_min) {
  let element;
  switch (block) {
    case "0":
      element = <img src="/img/calls_block_0.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} />;
      break;
    case "1":
      element = <div class="horizontal">
                    <div><img src="/img/calls_block_1.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} /></div>
                    <div><p>{epoch_min2date(epoch_min)}</p></div>
                </div>;
      break;
    case "2":
      element = <img src="/img/calls_block_2.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} />;
      break;
    default:
      element = <img src="/img/calls_block_unknown.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} />;
  }
  return <div>{element}</div>;
}

function gf_version(version) {
  if (typeof version !== 'string') return version;
  const parts = version.split('_');
  if (parts.length !== 3) {
    return version;
  }
  const [major, minor, patch] = version.split('_');
  if (!/^\d+$/.test(patch)) { // ensure patch is a number
    return version;
  }
  if (patch === '0') {
    return `${major}_${minor}`;
  }
  return version;
}

const DeviceTable = ({
    serial,
    data,
    updateTable,
    mqttReq
}) => {
    const [tableDeviceState, setTableDeviceState] = useState([]);

    const [luogoState, setLuogoState] = useState('')
    const [ambienteState, setAmbienteState] = useState('')
    const [wkmodeState, setWkmodeState] = useState('') // DB Version 0
    const [updateDeviceTableState, setUpdateDeviceTableState] = useState('')
    const handleLuogoChange = (event) => { setLuogoState(event.target.value) }
    const handleAmbienteChange = (event) => { setAmbienteState(event.target.value) }
    const handleWkmodeChange = (event) => { setWkmodeState(event.target.value) } // DB Version 0

    // includes
    const [includeLocation, setIncludeLocation] = useState(false);
    const [includeHouse, setIncludeHouse] = useState(false);
    const [includeWkMode, setIncludeWkMode] = useState(false); // DB Version 0

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setTableDeviceState(data)
    }, [data]);

    function prepareupdatedevicetable() {
        if (tableDeviceState?.location != null) setLuogoState(tableDeviceState.location);
        if (tableDeviceState?.house != null) setAmbienteState(tableDeviceState.house);
        if (tableDeviceState?.wk_mode != null) setWkmodeState(tableDeviceState.wk_mode); // DB Version 0
    }

    function updatedevicetable() {
        const post_body = {
            serial: serial,
            ...(includeLocation && { location: luogoState }),
            ...(includeHouse && { house: ambienteState }),
            ...(includeWkMode && { wk_mode: wkmodeState.toString() }), // DB Version 0
        };
        updateTable(post_body, '/devicemqttset', setUpdateDeviceTableState)
    }

    function refreshdevicetable() {
        mqttReq(serial, '/devicemqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px' }}>
                {isOpen ? 'Nascondi Device' : 'Mostra Device'}
            </button>
            {isOpen && (<>
                <table className="GatewayDBTable">
                    <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "5%" }} />
                    </colgroup>
                    <tbody>
                        {/* Title row */}
                        <tr>
                            <th className="tabletitle" colSpan="4">DEVICE</th>
                        </tr>

                        {/* Header row */}
                        <tr>
                            <th className="title">Campo</th>
                            <th className="title">Valore attuale</th>
                            <th className="title">Nuovo valore</th>
                            <th className="title">✔</th>
                        </tr>

                        {/* Luogo */}
                        <tr>
                            <td>Luogo</td>
                            <td style={{ textAlign: 'center' }}>{tableDeviceState?.location}</td>
                            <td>
                                <input type="text" value={luogoState} onChange={handleLuogoChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeLocation} onChange={() => setIncludeLocation(!includeLocation)} />
                            </td>
                        </tr>

                        {/* Ambiente */}
                        <tr>
                            <td>Ambiente</td>
                            <td style={{ textAlign: 'center' }}>{tableDeviceState?.house}</td>
                            <td>
                                <input type="text" value={ambienteState} onChange={handleAmbienteChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeHouse} onChange={() => setIncludeHouse(!includeHouse)} />
                            </td>
                        </tr>

                        {/* Versione SW */}
                        <tr>
                            <td>Versione SW</td>
                            <td style={{ textAlign: 'center' }}>{gf_version(tableDeviceState?.version)}</td>
                            <td className="noinput"></td>
                        </tr>

                        {/* Versione FS */}
                        <tr>
                            <td>Versione FS</td>
                            <td style={{ textAlign: 'center' }}>{gf_version(tableDeviceState?.dp_release)}</td>
                            <td className="noinput"></td>
                        </tr>

                        {/* ETH0 MAC */}
                        <tr>
                            <td>eth0 MAC</td>
                            <td style={{ textAlign: 'center' }}>{tableDeviceState?.eth0}</td>
                            <td className="noinput"></td>
                        </tr>

                        {/* WLAN0 MAC */}
                        <tr>
                            <td>wlan0 MAC</td>
                            <td style={{ textAlign: 'center' }}>{tableDeviceState?.wlan0}</td>
                            <td className="noinput"></td>
                        </tr>

                        {/* HW REBOOT DATE */}
                        <tr>
                            <td>giorno reboot HW
                              <span
                                className="help-icon"
                                title="Giorno dell'ultimo reboot HW."
                              >
                                ⓘ
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>{tableDeviceState?.hw_reboot_date}</td>
                            <td className="noinput"></td>
                        </tr>

                        {/* WK (mode) DB Version 0 */}
                        {tableDeviceState?.wk_mode && (
                        <tr>
                            <td style={{color: "red"}}>WK (mode)</td>
                            <td style={{ textAlign: 'center' }}>{tableDeviceState?.wk_mode}</td>
                            <td>
                                <input  type="text" value={wkmodeState} onChange={handleWkmodeChange}/>
                            </td>
                            <td>
                                <input type="checkbox" checked={includeWkMode} onChange={() => setIncludeWkMode(!includeWkMode)} />
                            </td>
                        </tr>
                        )}

                        {/* Ultimo aggiornamento */}
                        <tr>
                            <td className="timetitle">Ultimo aggiornamento</td>
                            <td style={{ textAlign: 'center' }}>{tableDeviceState?.time}</td>
                            <td style={{ textAlign: 'center' }}>{updateDeviceTableState}</td>
                        </tr>

                        {/* Buttons */}
                        <tr>
                            <td colSpan="3" style={{ textAlign: 'center' }}>
                                <button onClick={refreshdevicetable} style={{ marginRight: '20px' }}>aggiorna</button>
                                <button onClick={prepareupdatedevicetable} style={{ marginRight: '20px' }}>&gt;</button>
                                <button onClick={updatedevicetable}>invia</button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* led status icon */}
                <div class="horizontal">
                {
                tableDeviceState?.led
                    ? tableDeviceState?.led === "0"
                        ? <img src="/img/led-off.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} />
                        : <img src="/img/led-on.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} />
                    : <img src="/img/led-unknown.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} />
                }

                {/* call for falls block status */}
                {
                tableDeviceState?.calls_fall_blocked
                    ? CallFallsBlock(tableDeviceState.calls_fall_blocked, tableDeviceState.disable_fall_min_epoch)
                    : <img src="/img/calls_block_unknown.png" alt="LED Unknown" style={{ width: '50px', height: '50px' }} />
                }
                </div>
            </>)}
        </div>
    );
};

export default DeviceTable;
